<template>
    <div>
        <section :ref="`${selectID}-select-box`" class="input-group">
            <ui-input
                v-model="showDealName"
                :disabled="disabledInput"
                :loading="loader.name"
                :clear-error-on-focus="false"
                :required="isRequiredField"
                color-label="#5B6D8D"
                label="Nome Completo:"
                container-design="mgb-10"
                size="sm"
                type="text"
                complete-event="create-deal--verify-deal-name"
            >
                <section v-if="required" class="duplicity-found" @click="closeCardFound">
                    <small>Fechar</small>
                </section>

                <section
                    v-if="required"
                    v-position="$refs[`${selectID}-select-box`]"
                    class="container-select-deal-card scroll-color"
                >
                    <div class="container-title-subtitle">
                        <div class="title">Encontramos clientes semelhantes.</div>
                        <div class="subtitle">
                            Verifique se o cliente que você está tentando cadastrar já existe.
                        </div>
                    </div>

                    <div
                        v-for="(datas, index) in customersDuplicityFound"
                        :key="index"
                        class="container-card-content"
                    >
                        <div class="container-card-content-header">
                            <div class="name-identifier">
                                <div class="icon-user-residence">
                                    <em class="fal fa-user-circle" />

                                    <div class="user-residence">
                                        <span class="name-user">{{ existsData(datas.name) }}</span>

                                        <span class="residence">{{ getProductName(datas) }}</span>
                                    </div>
                                </div>

                                <div class="cadastral-analysis">
                                    <div class="analysis">{{ getStageStatus(datas).stage }}</div>

                                    <div class="cadastral">{{ getStageStatus(datas).status }}</div>
                                </div>
                            </div>

                            <div class="container-data-personal">
                                <div class="proposal-inditifier">
                                    <div
                                        v-if="getStageStatus(datas).stage == 'Proposta'"
                                        class="proposal"
                                    >
                                        {{ getStageStatus(datas).stage }}
                                    </div>

                                    <ui-tag-indicator
                                        v-if="datas.open_search"
                                        color="#1cca85"
                                        :text="datas.id_deal"
                                    />
                                </div>

                                <div class="email">
                                    Email:
                                    <span class="email-content">
                                        {{ existsData(datas.email) }}
                                    </span>

                                    <span class="tooltip-email">{{ existsData(datas.email) }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="cellphone">
                            <span class="cell">
                                Celular:
                                <span class="numbercell">
									{{ existsData(formatPhoneNew(datas.customer_country_code_mobile, datas.mobile)) }}
								</span>
                            </span>

                            <span class="phone">
                                Telefone:
                                <span class="numberphone">
									{{ existsData(formatPhoneNew(datas.customer_country_code_phone, datas.phone)) }}
								</span>
                            </span>
                        </div>

                        <div v-show="loading" class="loading-page">
                            <ui-load-indicator
                                bg-color="#e7e9f4"
                                color="#69D296"
                                :h="50"
                                :stroke="8"
                            />
                        </div>
                        <div class="details-button">
                            <span
                                v-if="datas.open_search"
                                class="view-details"
                                @click="openDetails(datas.id_deal)"
                            >
                                Visualizar detalhes
                            </span>
                            <div v-if="isProposal" class="actions-area">
                                <ui-button design="primary xs" @click="overrideCustomer(datas)">
                                    Criar novo negócio
                                </ui-button>

                                <ui-button
                                    v-if="datas.data && datas.data.length > 1"
                                    design="success xs"
                                    @click="selectDeal(datas.data)"
                                >
                                    Escolher Cliente
                                </ui-button>

                                <ui-button
                                    v-if="datas.data && datas.data.length === 1"
                                    design="success xs"
                                    @click="
                                        openCustomerPage(
                                            datas.id_deal,
                                            datas.funnel_stage_id,
                                            datas.funnel_stage_status_id,
											datas
                                        )
                                    "
                                >
                                    Preencher Proposta
                                </ui-button>
                            </div>
                            <div v-else>
                                <ui-button design="success xs" @click="overrideCustomer(datas)">
                                    Criar negócio para este cliente
                                </ui-button>
                            </div>
                        </div>
                    </div>
                </section>

                <section
                    v-if="disabled.name"
                    class="duplicity-has-been-found"
                    @click="clearDuplicityFound"
                >
                    <small class="duplicity-found clear">Limpar dados</small>
                </section>
            </ui-input>
        </section>
    </div>
</template>

<script>
import { uiInput } from '@/components/ui/form'
import { uiTagIndicator } from '@/components/ui/tags'
import { uiButton } from '@/components/ui/buttons'
import { uiLoadIndicator } from '@/components/ui'

import { utilMixin, formMixin, helpersMixin, maskIntl } from '@/mixins'

import { storage } from '@/services/storage'
import { product, funnel, customer, openSearch } from '@/services/axios'

import { getConfig } from '@/views/configurations/util/methods'

import axios from 'axios'

import { mapGetters } from 'vuex'

const defaultForm = () => ({
	name: '',
})

const defaultDisabled = () => ({
	name: false,
})

const defaultLoader = () => ({
	name: false,
})

const defaultComponentData = () => {
	return {
		form: { ...defaultForm() },
		disabled: { ...defaultDisabled() },
		loader: { ...defaultLoader() },

		customersDuplicityFound: [],

		products: [],
		stages: [],

		required: false,

		betaFeatures: null,
		abortToken: null,
	}
}

export default {
	name: 'ui-select-deal',

	components: {
		uiInput,
		uiTagIndicator,
		uiButton,
		uiLoadIndicator,
	},

	directives: {
		position: {
			inserted: function (el, binding) {
				el.style.top = '0px'

				const ref = binding.value
				const distance = ref.getBoundingClientRect()
				const body = document.body
				const elementHeight = el.clientHeight
				const referenceHeight = ref.clientHeight

				if (distance.top + elementHeight > body.clientHeight) {
					el.classList.add('options--open-up')
					el.classList.remove('options--open-down')
					el.style.top = `-${el.clientHeight}px`
				} else {
					el.style.top = `${referenceHeight - 2}px`
					el.classList.remove('options--open-up')
					el.classList.add('options--open-down')
				}
			},
		},
	},

	mixins: [utilMixin, formMixin, helpersMixin, maskIntl],

	props: {
		isRequiredField: {
			type: Boolean,
			default: false,
		},

		disabledInput: {
			type: Boolean,
			default: false,
		},

		isProposal: {
			type: Boolean,
			default: false,
		},

		submitMenuProposal: {
			type: Function,
			required: true,
		},

		value: {
			type: String,
			required: false
		}
	},

	data() {
		return {
			id: this._uid,
			...defaultComponentData(),
			setDeal: [],
			loading: false,
		}
	},

	computed: {
		selectID() {
			return 'select-' + this.id
		},

		...mapGetters('auth', { user: 'getUser' }),

		isDynamicUser() {
			return this.user && this.user.isDynamicGroup ? true : false
		},

		openSearchAllowed() {
			return (
				(this.betaFeatures &&
					this.betaFeatures.opensearch &&
					this.betaFeatures.opensearch[this.user.user_group]) == 1 ||
				(this.isDynamicUser && this.betaFeatures.opensearch['dynamic'] == 1)
			)
		},

		showDealName: {
			get() {
        	// Retornar o valor da prop 'value' quando a computed property for acessada
				return this.value
			},
			set(newValue) {
				// Emitir um evento para atualizar a prop 'value' quando a computed property for atualizada
				this.$emit('input', newValue)
			}
		}
	},

	watch: {
		'form.name': {
			handler(newValue) {
				this.$emit('input', newValue)
				this.required = false
			},

			deep: true,
		},
	},

	async mounted() {
		// Get options
		this.products = await this.getProducts()
		this.stages = await this.getStages()

		// To check open-search
		this.betaFeatures = JSON.parse(storage.get('beta_features'))

		// =================== event listener =================== //
		this.$root.$on('create-deal--verify-deal-name', async (value) => {
			await this.checkDuplicity(value)
		})

		this.$root.$on('create-deal-override-customer', (customer) => {
			// Load new data
			this.form['name'] = customer['name']

			// Block name field to change
			this.disabled.name = true
		})

		this.$root.$on('create-deal-clear-duplicity-found', () => {
			// Reset component data
			this.form = { ...defaultForm() }
			this.disabled = { ...defaultDisabled() }
			this.loader = { ...defaultLoader() }
			this.customersDuplicityFound = []
			this.required = false
		})
		// =================== end event listener =================== //
	},

	beforeDestroy() {
		// Destroy component data
		Object.assign(this.$data, { id: this._uid, ...defaultComponentData() })

		this.$root.$off('create-deal--verify-deal-name')
		this.$root.$off('create-deal-override-customer')
		this.$root.$off('create-deal-clear-duplicity-found')
	},

	methods: {
		closeCardFound() {
			this.required = false
		},

		openCardFound() {
			this.required = true
		},

		async getProducts() {
			try {
				const { data } = await product.getAll('')
				return data
			} catch (error) {
				console.log(error)
				return []
			}
		},

		async getStages() {
			try {
				return (await funnel.getStages()).data
			} catch (error) {
				console.log(error)
				return []
			}
		},

		async checkDuplicity(toFind) {
			if (this.abortToken) this.abortToken.cancel()

			if (!toFind || toFind == '') {
				// Stop duplicity check loading warning
				this.loader.name = false

				// Close card
				this.closeCardFound()

				return
			}

			// Axios 0.22 introduced the new https://developer.mozilla.org/en-US/docs/Web/API/AbortController
			// and made CancelToken deprecated. The facilita system is still using axios 0.19 so i will have to use CancelToken...
			this.abortToken = axios.CancelToken.source()

			try {
				// Start duplicity check loading warning
				this.loader.name = true
				this.customersDuplicityFound = []

				const response = this.openSearchAllowed
					? await openSearch.search(toFind, this.getInstance(), this.abortToken.token)
					: await customer.filter(toFind, this.abortToken.token)
				const data = this.openSearchAllowed
					? response.data.hits.hits
					: response.data.data

				if (data.length <= 0) {
					// Stop duplicity check loading warning
					this.loader.name = false

					// Close card
					this.closeCardFound()

					return
				}

				let hasExactlySameData = false
				data.forEach(dataCustomer => {
					let propData = dataCustomer

					if (this.openSearchAllowed) {
						propData = dataCustomer._source
						/**
						* Caso não receba o valor de customer_country_code, ira assumir o DDI brasileiro '55'
						* Necessário enquanto todos os números do banco de dados ainda não possuirem o DDI
						*/
						if(propData.customer_mobile){
							propData.customer_country_code_mobile = propData.customer_country_code_mobile ? propData.customer_country_code_mobile : 55
						}
						if(propData.customer_phone){
							propData.customer_country_code_phone = propData.customer_country_code_phone ? propData.customer_country_code_phone : 55
						}

						propData['id_deal'] = propData.id ? Number(propData.id) : null
						propData['id_customer'] = propData.customer_id
						propData['name'] = propData.customer_name
						propData['email'] = propData.customer_email
						propData['mobile'] = propData.customer_mobile
						propData['phone'] = propData.customer_phone
						propData['cpf'] = propData.customer_cpf

						propData['data'] = data.filter((value) => {
								return dataCustomer._source.customer_id == value._source.customer_id
							})

						// In the opensearch route, there is no data:
						// - CNPJ
						// - Type
						propData['owners'] = {
							team_id: null,
							broker_id: null,
							manager_id: null
						}

						// From open search route
						propData['open_search'] = true

						// No conflit data
						delete propData['id']
					}

					if(this.isProposal) {
						const alreadyInData = this.customersDuplicityFound.find(
						(alreadyItemInData) =>
							propData['id_customer'] == alreadyItemInData['id_customer']
					)

					// Check if this same object does not exist
						if (!alreadyInData) {
							propData['checked'] = false
							this.customersDuplicityFound.push(propData)
						}
					} else {
						this.customersDuplicityFound.push(propData)
					}

					if (!hasExactlySameData && propData.name && toFind) {
						hasExactlySameData = this.$mx_isEqual(propData.name, toFind)
					}

					// Open card to view
					this.openCardFound()
				})

				// Stop duplicity check loading warning
				this.loader.name = false

			} catch (error) {
				console.log(error)
			}
		},
		formatedCPF(value) {
			if (!value || value == '' || Array.isArray(value)) {
				return null
			}

			value = value.replace(/[^\d]/g, '')
			return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
		},

		formatedPhone(value) {
			if (!value || value == '' || Array.isArray(value)) {
				return null
			}

			return value
				.replace(/\D/g, '')
				.replace(/(\d{2})(\d)/, '($1) $2')
				.replace(/(\d{4})(\d)/, '$1-$2')
				.replace(/(\d{4})-(\d)(\d{4})/, '$1$2-$3')
				.replace(/(-\d{4})\d+?$/, '$1')
		},
		async openCustomerPage(id, stage, status, customer) {
			this.$root.$emit('customer-page-opened', id, stage, status)
			this.$emit('handle-full-modal')
			this.$root.$emit('create-deal-override-customer', customer)
			this.submitMenuProposal()
		},
		openDetails(id) {
			const customerURL = this.$mx_oldPanelLink('vendas/negocios/' + id)
			window.open(customerURL)
		},
		getConfig,
		existsData(value) {
			return value && value != '' && !Array.isArray(value) ? value : 'Não cadastrado.'
		},
		properDeal(customer_id, deals) {
			const properDeal = deals.filter((item) => item.customer_id == customer_id)[0]
			return properDeal
		},
		getProductName(customer) {
			const deal = this.openSearchAllowed
				? customer
				: this.properDeal(customer.id_customer, customer.deals)

			if (!deal || deal == '' || Array.isArray(deal)) {
				return 'Sem empreendimento'
			}

			const product = this.products.filter((item) => item.id == deal.product_id)[0]

			if (!product || product == '' || Array.isArray(product)) {
				return 'Sem empreendimento'
			}

			return product.name
		},
		getStageStatus(customer) {
			const deal = this.openSearchAllowed
				? customer
				: this.properDeal(customer.id_customer, customer.deals)

			if (!deal || deal == '' || Array.isArray(deal)) {
				return {
					stage: 'Sem etapa',
					status: 'Sem status',
				}
			}

			const stage = this.stages.filter((item) => item.id == deal.funnel_stage_id)[0]
			const stageName =
				stage && stage != '' && !Array.isArray(stage) ? stage.name : 'Sem etapa'

			const status = stage.status.filter((item) => item.id == deal.funnel_stage_status_id)[0]
			const statusName =
				status && status != '' && !Array.isArray(status) ? status.name : 'Sem status'

			return {
				stage: stageName,
				status: statusName,
			}
		},
		overrideCustomer(customer) {
			// Dispatch event to override customer on nugget-customer-form
			this.$root.$emit('create-deal-override-customer', customer)

			// Close the card
			this.closeCardFound()
		},
		clearDuplicityFound() {
			// Dispatch event to nugget-customer-form
			this.$root.$emit('create-deal-clear-duplicity-found')
		},
		selectDeal(deals) {
			this.$root.$emit('select-deal-override-customer', Array.from(deals))
		}
	}
}
</script>

<style lang="stylus" scoped>
@import './styles.styl';
</style>
